/* eslint-disable jsx-a11y/anchor-is-valid */
import { TableFilter } from "@neonumy/ant-design";
import { useGetWindowHeight } from "@neonumy/neonumy-ui";
import { Space, Typography } from "antd";
import { Content } from "antd/es/layout/layout";
import Footer from "components/Footer/Footer";
import { routes } from "config/routes";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useCoreStore from "views/hooks/useCoreStore";
import CreateUpdateCategory from "./components/createUpdateCategory";
import RemoveButton from "./components/RemoveButton";
import useCategoryApi from "./hooks/useCategoryApi";

export default function Categories(): React.ReactElement {
  const windowHeight = useGetWindowHeight();
  const urlParams: RouteParams = useParams();
  const FILTER_INIT = {
    name_Istartswith: undefined,
    company: urlParams.companyId,
  };
  const paginationInit = {
    offset: 0,
    limit: 10,
  };

  const { t } = useTranslation();
  const [filters, setFilters] = useState(FILTER_INIT);

  const { refetch, loading, dataSource, listCategories, totalCount } = useCategoryApi(
    urlParams.clientId,
  );
  const setCategoryId = useCoreStore(state => state.setCategoryId);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handleOnClickProductCount = (id: ID) => {
    setCategoryId(id);

    routes.navigate(`/company/${urlParams?.companyId}/catalog/products`);
  };

  const COLUMNS = [
    {
      title: t("Name"),
      dataIndex: "name",
      key: "name",
      sorter: true,
      filterType: {
        type: "SearchFilter",
        varName: "name_Istartswith",
      },
    },
    {
      title: t("Reference"),
      dataIndex: "reference",
      key: "reference",
    },
    {
      title: t("Product count"),
      dataIndex: "productCount",
      key: "productCount",
      render: (_text: unknown, record: Record<string, any>) => {
        return (
          <span>
            <a onClick={() => handleOnClickProductCount(record?.id)}>{record?.productCount}</a>
          </span>
        );
      },
    },
    {
      dataIndex: t("Action"),
      key: "action",
      title: "Action",
      align: "left",
      className: "category-action-column",
      width: "100px",
      fixed: "right",
      render: (_text: unknown, record: Record<string, any>) => {
        return (
          <Space size="small" direction="horizontal" className="centered">
            <CreateUpdateCategory id={record.id} refetch={refetch} />
            {record?.productCount === 0 && <RemoveButton id={record.id} refetch={refetch} />}
          </Space>
        );
      },
    },
  ];

  useEffect(() => {
    if (urlParams.companyId) {
      listCategories({
        variables: {
          filter: filters,
          ...paginationInit,
        },
      });
    }
  }, [urlParams.companyId]);

  const handleSearchFilters = (confirm: () => void) => {
    confirm();

    if (urlParams.companyId) {
      listCategories({ variables: { filter: { ...filters }, ...paginationInit } });
    }
  };

  const handleResetFilter = (_filterList: unknown, confirm: () => void) => {
    confirm();
    listCategories({ variables: { filter: { ...FILTER_INIT }, ...paginationInit } });
  };

  const handlePagination = (page: number, size: number) => {
    setPageSize(size);
    setCurrentPage(page);
    refetch({
      limit: size,
      offset: size * (page - 1),
    });
  };

  return (
    <>
      <Content className="layout-card-content">
        <Typography.Title className="documents-title" level={4}>
          {t("Categories")}
        </Typography.Title>
        <TableFilter
          className="antd-newrai-table"
          scroll={{ y: windowHeight - 350 }}
          dataSource={dataSource}
          loading={loading}
          columns={COLUMNS}
          defaultSearchFilter={handleSearchFilters}
          defaultResetFilter={handleResetFilter}
          defaultFiltersObject={filters}
          defaultFilterSet={setFilters}
          pagination={{
            onChange: handlePagination,
            showSizeChanger: true,
            current: currentPage,
            pageSize: pageSize,
            total: totalCount,
            showTotal: total => t("Total table items", { count: total }),
          }}
          debounced={true}
        />
        <CreateUpdateCategory refetch={refetch} />
      </Content>
      <Footer />
    </>
  );
}
